import axios from 'axios';
import { getAuthToken, useAuthStore } from '../store/authStore';

const API_KEY = import.meta.env.VITE_API_KEY || 'Brunji1342Deguzaro@!#!@#';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'x-api-key': API_KEY,
  },
  // Envia o cookie mtz_auth (.grupomultiluz.com.br) automaticamente.
  // Necessário pra autenticação compartilhada funcionar dentro do iframe Pipefy.
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Token do auth central (usuariospipefy) — só anexa se o usuário logou.
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Token expirado ou inválido: limpa sessão e manda pra /login,
      // mas só se já estávamos logados (pra não redirecionar em pages legadas
      // que ainda usam só x-api-key e nunca tiveram token).
      const state = useAuthStore.getState();
      if (state.isAuthenticated) {
        state.logout();
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?next=${next}`;
      }
    }
    return Promise.reject(err);
  }
);

export default api;
